/* eslint-disable complexity */
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
// External library
import * as CryptoJS from 'crypto-js';
// Environments
import { environment as env } from '../../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	constructor(){}
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// add authorization header with jwt token if available
		let currentUser : any;
		const auth = request.headers.get('auth') ? request.headers.get('auth') : 'true';
		try{
			let userJson: any;
			try{
				userJson = localStorage.getItem("currentUser");
			}catch(err){ /* empty */ }
			currentUser = userJson !== null ? JSON.parse(userJson) : null;
		}
		catch{ /* empty */ }
		if(auth == 'false'){
			request = request.clone({
				headers: request.headers.delete('auth')
			});
		}else  if (currentUser && currentUser.token && currentUser.Ip) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${currentUser.token}`,
					Ip: currentUser.Ip
				}
			});
		}
		// We will not pass these headers with those API's which have auth == 'false'
		if(auth != 'false'){
			request = request.clone({
				setHeaders: this.setSessionHeaders()
			});
		}
		return next.handle(request);
	}
	/**
	 * Generates the necessary headers for a session authentication request.
	 * Set header values for a session. It generates values for 'Period', 'Session-Token', and 'Auth-Session' headers and returns them as an object
	*/
	private setSessionHeaders(): any {
		//Generate alphanumeric session token
		let sessionToken: string = this.genSessionToken();
		let aesKey: any = CryptoJS.enc.Utf8.parse(env.encryptionKey);
		let aesIv: any = CryptoJS.enc.Utf8.parse(env.encryptionIv);

		//Get current UTC timestamp in seconds
		// let timestampStr: string = (dayjs().unix()).toString();
		let timestampStr: string = (Math.round(new Date().getTime() / 1000)).toString();
		let aesTimestamp: any = CryptoJS.enc.Utf8.parse(timestampStr);

		//Encrypt timestamp using AES encryption
		// Live
		// let period: string = (CryptoJS.AES.encrypt(aesTimestamp, aesKey, {
		// 	iv: aesIv
		// }).ciphertext).toString();
		// Staging
		let period: string = CryptoJS.AES.encrypt(aesTimestamp, aesKey, {
			iv: aesIv
		}).toString();

		//Combine timestamp and session token
		let authSession: string = timestampStr+sessionToken;
		//Create object with headers
		let headers: any = {
			'Period': period,
			'Session-Token': sessionToken,
			'Auth-Session': CryptoJS.SHA512(authSession).toString()
		}
		//Return headers object
		return headers;
	}
	/**
	 * Generates a session token of 20 charector alphanumeric string.
	 * It first creates a random number between 0 and 36^20,
	 * which is then subtracted from 36^5.
	 * The resulting value is then converted to a base-36 string
	 * and sliced to remove the leading digit.
	 * The resulting session token is returned.
	 * @returns {string} The generated session token.
	 */
	private genSessionToken(): any {
		return (Math.random().toString(36).slice(2)).toString()+(Math.random().toString(36).slice(2)).toString();
	}
}
